import config from './config';

export async function login(email: string, password: string) {
  const res = await fetch(`${config.apiUrl}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok || !data.access_token) {
    throw new Error(data.message || "Ошибка авторизации");
  }
  
  // Проверяем, что пользователь является админом (roleId = 1)
  if (data.roleId !== 1) {
    throw new Error("Доступ запрещен. Требуются права администратора.");
  }
  
  return data;
}

export async function getCurrentUser() {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("Токен не найден");
  }
  
  const res = await fetch(`${config.apiUrl}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  
  if (!res.ok) {
    throw new Error("Ошибка получения данных пользователя");
  }
  
  const data = await res.json();
  
  // Проверяем, что пользователь является админом (roleId = 1)
  if (data.roleId !== 1) {
    throw new Error("Доступ запрещен. Требуются права администратора.");
  }
  
  return data;
}

export async function getCourses() {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/courses`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки курсов");
  const data = await res.json();
  return data.data;
}

export async function getCourse(id: number) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/courses/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки курса");
  const data = await res.json();
  return data;
}

export async function updateCourse(id: number, courseData: {
  title: string;
  description?: string;
  image_url?: string;
  status?: 'draft' | 'published';
}) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/courses/${id}`, {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(courseData),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка обновления курса");
  }
  return await res.json();
}

export async function createCourse(courseData: {
  title: string;
  description?: string;
  image_url?: string;
  status?: 'draft' | 'published';
}) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/courses`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(courseData),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка создания курса");
  }
  return await res.json();
}

// Lessons API
export async function getLessons() {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/lessons`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки уроков");
  const data = await res.json();
  return data;
}

export async function getLesson(id: number) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/lessons/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки урока");
  const data = await res.json();
  return data;
}

export async function createLesson(lessonData: {
  courseId: number;
  title: string;
  content?: string;
  sort_order: number;
  examType: 'test' | 'open';
}) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/lessons`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(lessonData),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка создания урока");
  }
  return await res.json();
}

export async function updateLesson(id: number, lessonData: {
  courseId?: number;
  title?: string;
  content?: string;
  sort_order?: number;
  examType?: 'test' | 'open';
}) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/lessons/${id}`, {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(lessonData),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка обновления урока");
  }
  return await res.json();
}

// Users API
export async function getUsers() {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/users`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки пользователей");
  const data = await res.json();
  return data;
}

export async function getUser(id: number) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/users/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки пользователя");
  const data = await res.json();
  return data;
}

export async function updateUser(id: number, userData: {
  phone?: string;
  roleId?: number;
}) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/users/${id}`, {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(userData),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка обновления пользователя");
  }
  return await res.json();
}

export async function deleteUser(id: number) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/users/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка удаления пользователя");
  }
  return await res.json();
}

export async function changeUserPassword(id: number, newPassword: string) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/admin/users/${id}/password`, {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify({ newPassword }),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка смены пароля");
  }
  return await res.json();
}

// API функции для инвайтов
export async function getInvites() {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/invites/all`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Ошибка загрузки инвайтов");
  return await res.json();
}

export async function createInvite(inviteData: {
  email?: string;
  expiresIn?: string;
}) {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${config.apiUrl}/invites`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(inviteData),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка создания инвайта");
  }
  return await res.json();
}

export async function checkInvite(code: string) {
  const res = await fetch(`${config.apiUrl}/invites/check`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "Ошибка проверки инвайта");
  }
  return await res.json();
} 